var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4,
    fill: "#E5E5E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3275 3.73253C8.60261 3.17509 9.3975 3.17509 9.67261 3.73253L10.9485 6.31776L13.8015 6.73233C14.4166 6.82172 14.6623 7.57769 14.2171 8.0116L12.1527 10.0239L12.64 12.8654C12.7451 13.4781 12.1021 13.9453 11.5518 13.656L9.00005 12.3145L6.44827 13.656C5.89805 13.9453 5.25498 13.4781 5.36006 12.8654L5.84741 10.0239L3.78297 8.0116C3.33784 7.57769 3.58347 6.82172 4.19863 6.73233L7.05161 6.31776L8.3275 3.73253Z",
    fill: "#8278F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.af0a95ef50a6481b522a1c5f296dd1e1.svg";
export { ForwardRef as ReactComponent };